// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__39ntl","selects":"Documents_selects__W7SnN"};